export default __webpack_public_path__ + "static/media/mainbanner_1.2b4bb029.jpg";